// Copyright (c) 2023, Comsearch, Inc., All rights reserved

import { useModalContext } from 'components/ModalContext'
import ConfirmationModal from 'components/Modals/ConfirmationModal'
import React, { useCallback } from 'react'
import { success } from 'react-notification-system-redux'
import { useDispatch } from 'react-redux'

const useDeleteComment = props => {
  const {
    deleteComment,
    idRoot,
    removeComment,
    rowData,
  } = props

  const commentId = rowData[rowData.uniqueId]

  const dispatch = useDispatch()

  const {
    closeContextModal,
    openContextModal,
  } = useModalContext()

  return useCallback(() => {
    const confirmAction = async () => {
      const message = await removeComment(commentId)

      if (message) {
        dispatch(success({ message }))
        closeContextModal()
      }
    }

    openContextModal(
      <ConfirmationModal
        confirmAction={confirmAction}
        heading={'Delete Comment:'}
        idRoot={`${idRoot}-confirmation`}>
        <p id={`${idRoot}-confirmation-message`}>
          {'Are you sure you want to delete this comment?'}
        </p>
      </ConfirmationModal>
    )
  }, [deleteComment])
}

export default useDeleteComment
